module.exports = __webpack_public_path__ + "img/article-img.515e1ee0.png";